import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileSpreadsheet, FileType2, Presentation, FileText } from "lucide-react";
import api, { gbp, img } from "@/lib/api";

const RANGE_KEYS = ["money", "planners", "learning", "creators"];

export const TemplatesSpotlight = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/workplace-documents").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  const products = (data.products || []).filter((p) => p.brand === "MRQK Templates");
  if (!products.length) return null;
  const ranges = (data.ranges || []).filter((r) => RANGE_KEYS.includes(r.key));
  const picks = products.filter((p) => p.featured).slice(0, 4);
  const fromPrice = Math.min(...products.map((p) => p.price));
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-20" data-testid="home-templates-spotlight">
      <div className="grid grid-cols-1 lg:grid-cols-5 border border-neutral-200">
        <div className="lg:col-span-2 bg-[#0E7490] text-white p-8 md:p-10 flex flex-col">
          <span className="label-caps text-[#A5F3FC] flex items-center gap-2"><FileSpreadsheet className="w-4 h-4" />MRQK Templates · new</span>
          <h2 className="font-heading text-2xl md:text-3xl tracking-tight font-medium mt-2 mb-3">Spreadsheets & planners that open in Excel, Word, PowerPoint and PDF</h2>
          <p className="text-sm text-cyan-50/90 leading-relaxed mb-6">{products.length} UK templates from {gbp(fromPrice)} — budget, ISA and side-hustle trackers in pounds, landlord MTD, ADHD and academic planners, wedding stationery and kids' worksheets. Fill them in, make them yours and send them on.</p>
          <div className="flex items-center gap-3 text-cyan-100 mb-8">
            <FileSpreadsheet className="w-5 h-5" /><FileType2 className="w-5 h-5" /><Presentation className="w-5 h-5" /><FileText className="w-5 h-5" />
            <span className="text-xs">Excel · Word · PowerPoint · PDF · Google Workspace</span>
          </div>
          <div className="flex flex-wrap gap-2 mb-8">
            {ranges.map((r) => <Link key={r.key} to={`/mrqk-templates?cat=${r.key}`} className="text-xs border border-white/30 px-3 py-1.5 hover:bg-white hover:text-[#0E7490] transition-colors" data-testid={`home-templates-range-${r.key}`}>{r.label} · {r.count}</Link>)}
          </div>
          <Link to="/mrqk-templates" data-testid="home-templates-cta" className="mt-auto bg-white text-[#0E7490] px-6 py-3 font-medium hover:bg-[#FFC107] hover:text-black transition-colors inline-flex items-center gap-2 self-start">Browse all templates <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="lg:col-span-3 grid grid-cols-2 gap-px bg-neutral-200">
          {picks.map((p) => (
            <Link key={p.id} to={`/product/${p.slug}`} className="bg-white p-4 flex gap-3 hover:bg-neutral-50 transition-colors group" data-testid={`home-templates-pick-${p.id}`}>
              <img src={img(p.images?.[0], 240)} alt="" loading="lazy" decoding="async" className="w-20 h-20 object-cover shrink-0 group-hover:scale-[1.03] transition-transform duration-500" />
              <div className="min-w-0">
                <p className="text-sm font-medium leading-snug line-clamp-2 mb-1">{p.title}</p>
                <p className="text-[11px] text-neutral-500 uppercase tracking-wider">{p.file_format === "xlsx" ? "Excel · Google Sheets" : p.file_format === "zip" ? "Bundle" : "PDF · A4 printable"}</p>
                <p className="font-heading text-base font-semibold mt-1">{gbp(p.price)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
